export enum Page {
	FIRST_NAME,
	LAST_NAME,
	EMAIL,
	PHONE,
	ADDR,
	FUNFACT,
	DOB,
	GENDER,
	PRACTICE,
	CARE,
	TYPE_OF_CARE,
	GENETIC_TESTING,
	GENETIC_TESTING2,
	INS_DISCLAIMER,
	INS,
	INS_CARD,
	LAST_DETAILS,
	PHARMACY,
	EMERGENCY_CONTACTS,
	INTERFACE,
	DAY_PREF,
	TIME_PREF,
	SPECIALTIES,
	GENDER_PREF,
	ETHNICITIY,
	MATCH,
	DONE
}